import PropTypes from "prop-types";

const CareEventType = PropTypes.shape({
  quantity: PropTypes.number.isRequired,
  price: PropTypes.shape({
    totalAmount: PropTypes.number,
    currency: PropTypes.string,
  }).isRequired,
  eventPrice: PropTypes.shape({
    name: PropTypes.string,
    careRequest: PropTypes.string,
  }).isRequired,
});

/** @deprecated */
export const TransactionType = PropTypes.shape({
  uuid: PropTypes.string.isRequired,
  method: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  authCode: PropTypes.string,
  price: PropTypes.shape({
    amountInPence: PropTypes.number.isRequired,
    waivedAmountInPence: PropTypes.number,
  }),
});

/** @deprecated */
const InvoiceType = PropTypes.shape({
  admission: PropTypes.shape({
    admissionNumber: PropTypes.number,
    admissionDate: PropTypes.string,
    dischargeDate: PropTypes.string,
  }),
  status: PropTypes.string.isRequired,
  invoiceNumber: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  type: PropTypes.string,
  careEvents: PropTypes.arrayOf(CareEventType),
  balance: PropTypes.shape({}),
  transactions: PropTypes.arrayOf(TransactionType),
  issuer: PropTypes.shape({
    reporterDetails: PropTypes.shape({
      person: PropTypes.shape({
        firstname: PropTypes.string,
        lastname: PropTypes.string,
      }),
    }),
  }).isRequired,
  meta: PropTypes.shape({ created: PropTypes.string }).isRequired,
});

export default InvoiceType;
